import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UtilsService {
  window: any;

  constructor(@Inject(DOCUMENT) private _document) {
    this.window = _document.defaultView;
  }

  topScrollPage() {
    setTimeout(() => {
      this.window.scrollTo({ top: 0, behavior: "smooth" });
    }, 300);
  }
}
